<script>
import IconChevronDown from "@js/components/Icons/IconChevronDown.vue";
import {usePage} from "@inertiajs/vue3";

export default {
    components: {IconChevronDown},
    data() {
        return {
            faqs: [
                {
                    question: 'Какое качество бетонных плит вы гарантируете?',
                    answer: 'Все наши бетонные плиты проходят строгий контроль качества. Мы используем только сертифицированные материалы и современные технологии производства, что гарантирует их прочность, долговечность и устойчивость к нагрузкам.',
                    isOpen: true
                },
                {
                    question: 'Как оформить заказ на бетонные плиты?',
                    answer: 'Вы можете оформить заказ через наш сайт, позвонив по телефону или посетив наш офис. Мы готовы проконсультировать вас по выбору плит и помочь рассчитать необходимый объем.',
                    isOpen: false
                },
                {
                    question: 'Как рассчитывается стоимость бетонных плит?',
                    answer: 'Стоимость бетонных плит зависит от их типа, размеров, объема заказа и условий доставки. Мы предлагаем прозрачное ценообразование и скидки для оптовых клиентов.',
                    isOpen: false
                },
                {
                    question: 'Подходят ли ваши бетонные плиты для дорожного строительства?',
                    answer: 'Да, наши дорожные плиты отличаются высокой прочностью и долговечностью, что делает их идеальными для строительства автомобильных дорог, площадок и тротуаров.',
                    isOpen: false
                },
                {
                    question: 'Какие материалы используются для производства бетонных плит?',
                    answer: 'Для производства наших бетонных плит используются высококачественный цемент, песок, щебень и арматура. Все материалы проходят строгий отбор и соответствуют нормативным требованиям.',
                    isOpen: false
                },
            ]
        };
    },
    methods: {
        toggleFAQ(index) {
            this.faqs = this.faqs.map((faq, i) => ({
                ...faq,
                isOpen: i === index ? !faq.isOpen : false
            }));
        },
        insertSchemaMarkup() {
            if (typeof window !== "undefined") {
                const scriptId = "schema-faq-jsonld"
                let script = document.getElementById(scriptId)

                if (script) {
                    script.remove()
                }

                script = document.createElement("script")
                script.id = scriptId
                script.type = "application/ld+json"
                script.textContent = JSON.stringify({
                    "@context": "https://schema.org",
                    "@type": "FAQPage",
                    "mainEntity": this.faqs.map((faq, index) => ({
                        "@type": "Question",
                        "name": faq.question,
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": faq.answer
                        }
                    }))
                })

                document.head.appendChild(script);
            }
        },
        removeSchemaMarkup() {
            const script = document.getElementById("schema-faq-jsonld")
            if (script) {
                script.remove()
            }
        }
    },
    mounted() {
        this.insertSchemaMarkup()
    },
    beforeUnmount() {
        this.removeSchemaMarkup()
    },
};
</script>

<template>
    <div class="pt-20">
        <div class="max-w-[750px] mx-auto p-4">
            <h2 class="font-semibold text-xl md:text-3xl leading-tight mb-5 text-center">
                Вопросы и ответы
            </h2>
            <div v-for="(faq, index) in faqs" :key="index" class="border-b">
                <button @click="toggleFAQ(index)"
                        class="flex items-center justify-between text-left w-full py-5 font-medium text-gray-500 border-b border-gray-200 gap-3">
                    <span class="text-base md:text-lg font-medium">{{ faq.question }}</span>
                    <IconChevronDown :rotate="faq.isOpen" class="w-4 h-4 shrink-0 text-gray-800"/>
                </button>
                <div v-if="faq.isOpen" class="py-5 border-b border-gray-200">
                    <p class="text-sm mb-2 text-gray-800">
                        {{ faq.answer }}
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
button:focus {
    outline: none;
}
</style>
